var map = {
	"./ee/privacy.json": [
		2826,
		826
	],
	"./ee/terms.json": [
		9425,
		425
	],
	"./en/privacy.json": [
		11,
		11
	],
	"./en/terms.json": [
		8272,
		272
	],
	"./fi/privacy.json": [
		1077,
		77
	],
	"./fi/terms.json": [
		654,
		654
	],
	"./no/privacy.json": [
		3575,
		575
	],
	"./no/terms.json": [
		3132,
		132
	],
	"./ru/privacy.json": [
		3458,
		458
	],
	"./ru/terms.json": [
		8334,
		334
	],
	"./se/privacy.json": [
		4800,
		800
	],
	"./se/terms.json": [
		2835,
		835
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3803;
module.exports = webpackAsyncContext;